import React from "react";
let searchTimeout = null;

export default class Searchbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: this.props.defaultText || "",
      searchPending: false,
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.defaultText !== prevProps.defaultText) {
      this.setState({ searchText: this.props.defaultText });
    }
  }
  handleSearch = (searchText) => {
    this.setState({ searchText, searchPending: true });

    if (this.props.immediate) {
      this.goSearch(searchText);
      this.props.onSearch(searchText);
    } else {
      window.clearTimeout(searchTimeout);
      searchTimeout = window.setTimeout(() => {
        this.props.onSearch(searchText);
        this.goSearch(searchText);
      }, this.props.timeout || 1000);
    }
  };

  goSearch = (searchText) => {
    this.setState({
      searchPending: false,
      searchText,
    });
  };

  handleSearchCancell = () => {
    window.clearTimeout(searchTimeout);
    this.setState({
      searchPending: false,
      searchText: "",
    });
    this.props.onSearch("");
  };
  render() {
    const placeholder = this.props.placeholder || "Поиск...";
    return (
      <div className="input-group">
        <input
          ref={this.props.inputRef}
          className="form-control form-control-solid d-inline-block w-auto"
          type="text"
          placeholder={placeholder}
          value={this.state.searchText || ""}
          onChange={(e) => this.handleSearch(e.target.value)}
        />
        {this.state.searchText && !this.state.searchPending ? (
          <div className="input-group-append">
            <button
              title="Отменить поиск"
              className="btn btn-icon btn-secondary"
              type="button"
              onClick={() => this.handleSearchCancell()}
            >
              <i className="fa text-muted fa-close"></i>
            </button>
          </div>
        ) : null}
        {this.state.searchPending ? (
          <div className="input-group-append">
            <div className="btn btn-icon btn-light">
              <div className="spinner mr-5"></div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
